module.exports = __webpack_public_path__ + "worm.jpg?18bcc6634783d413bc631236c3fb2613";